import { Card, Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { getApi } from '../api/endpoints';

const ComplaintCategoriesStats = () => {
  const [categoriesApi] = getApi('categories');
  const [catgoriesCount, setCatgoriesCount] = useState(0);

  useEffect(() => {
    fetchCategories();
  }, [])

  const fetchCategories = async () => {
    try {
      const response = await categoriesApi({ fields: 'options' }).unwrap();
      setCatgoriesCount(response.data.categories.length);
    } catch (error) {
    }
  }

  return <div className="categories-stats mb-3">
    <Row>
      <Col lg={{ span: 3 }} className='mb-2'>
        <Card className='shadow-sm'>
          <Card.Body>
            <Card.Title>Total Categories</Card.Title>
            <Card.Text>
              {catgoriesCount}
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </div>
}

export default ComplaintCategoriesStats;
